module.exports = __webpack_public_path__ + "img/vip2.facf3871.png";